import {
  DataGridBody,
  DataGridRow,
  DataGrid,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridCell,
  createTableColumn
} from '@fluentui/react-components';
import { getReasonLabel } from '../constants/reasons';

const columnSizingOptions = {
  reason: {
    idealWidth: 150,
  },
  comment: {
    idealWidth: 160,
  },
  before: {
    idealWidth: 120,
  },
  after: {
    idealWidth: 120,
  },
  username: {
    idealWidth: 184,
  },
  updatedAt: {
    minWidth: 160
  },
};

const columns = [
  createTableColumn({
    columnId: "reason",
    renderHeaderCell: () => <strong>Raison</strong>,
    renderCell: (item) => item.reason.label
  }),
  createTableColumn({
    columnId: "comment",
    renderHeaderCell: () => <strong>Commentaire</strong>,
    renderCell: (item) => item.comment.label
  }),
  createTableColumn({
    columnId: "before",
    renderHeaderCell: () => <strong>Avant</strong>,
    renderCell: (item) => item.before.label
  }),
  createTableColumn({
    columnId: "after",
    renderHeaderCell: () => <strong>Après</strong>,
    renderCell: (item) => item.after.label
  }),
  createTableColumn({
    columnId: "username",
    renderHeaderCell: () => <strong>Utilisateur</strong>,
    renderCell: (item) => item.username.label
  }),
  createTableColumn({
    columnId: "updatedAt",
    compare: (a, b) => a.eUpdatedAt.timestamp - b.eUpdatedAt.timestamp,
    renderHeaderCell: () => <strong>Date et Heure</strong>,
    renderCell: (item) => item.updatedAt.label
  }),
];

const makeItems = (historyItems) => {
  const formatThresholds = (before, after) => {

    const boldIfDifferent = (value, otherValue) =>
      <>{value === otherValue ? value : <b>{value}</b>}</>

    const formattedBefore = (
      <p>
        Seuil Min: {boldIfDifferent(before.eMin, after.eMin)}<br />
        Cible: {boldIfDifferent(before.eTarget, after.eTarget)}<br />
        Seuil Max: {boldIfDifferent(before.eMax, after.eMax)}
      </p>
    );

    const formattedAfter = (
      <p>
        Seuil Min: {boldIfDifferent(after.eMin, before.eMin)}<br />
        Cible: {boldIfDifferent(after.eTarget, before.eTarget)}<br />
        Seuil Max: {boldIfDifferent(after.eMax, before.eMax)}
      </p>
    );

    return [formattedBefore, formattedAfter];
  };

  return historyItems.map(({ before, after, eUpdatedAt, eUsername, eComment, eReason }) => {
    const [formattedBefore, formattedAfter] = formatThresholds(before, after);
    return {
      updatedAt: {
        label: new Date(eUpdatedAt).toLocaleString(),
        timestamp: new Date(eUpdatedAt).getTime()
      },
      username: { label: eUsername || "Inconnu" },
      reason: { label: getReasonLabel(eReason) },
      comment: { label: eComment || "" },
      before: { label: formattedBefore },
      after: { label: formattedAfter },
    };
  });
};

const RecipeHistoryTable = ({ recipeFull, historyItems, isLoading }) =>
  isLoading ? (
    <div>Loading...</div>
  ) : (
    <DataGrid
      items={makeItems(historyItems)}
      columns={columns}
      sortable
      resizableColumns
      columnSizingOptions={columnSizingOptions}
      resizableColumnsOptions={{autoFitColumns: false}}
    >
      <DataGridHeader>
        <DataGridRow>
          {({ renderHeaderCell }) => (
            <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
          )}
        </DataGridRow>
      </DataGridHeader>
      <DataGridBody>
        {({ item, rowId }) => (
          <DataGridRow key={rowId}>
            {({ renderCell }) => (
              <DataGridCell>{renderCell(item)}</DataGridCell>
            )}
          </DataGridRow>
        )}
      </DataGridBody>
    </DataGrid>
  );

export default RecipeHistoryTable;
